import { TFunction } from 'i18next';

import { TLanguage } from 'config/tenancy';
import { ICONS, TIconType } from 'shared/presentation/constants/icons';
import { TRoutePathsWithParams } from 'shared/presentation/contexts';

type TMenuLink = (params: { t: TFunction<'shared'> }) => {
  to: TRoutePathsWithParams;
  icon: TIconType;
  text: string;
  enabledTenancies?: TLanguage[];
};

const CONTRACTS: TMenuLink = ({ t }) => ({
  to: '/area-cliente/contratos',
  icon: ICONS.DOCUMENT,
  text: t('Contracts'),
});

const CUSTOMER_AREA: TMenuLink = ({ t }) => ({
  to: '/area-cliente/inicio',
  icon: ICONS.HOME,
  text: t('Customer area'),
});

const MY_DATA: TMenuLink = ({ t }) => ({
  to: '/area-cliente/perfil',
  icon: ICONS.LIST,
  text: t('My data'),
});

const RECOMMENDATIONS: TMenuLink = ({ t }) => ({
  to: '/area-cliente/indicacoes',
  icon: ICONS.GIFT,
  text: t('My recommendations'),
  enabledTenancies: ['pt'],
});

const SESSIONS: TMenuLink = ({ t }) => ({
  to: '/area-cliente/tratamentos',
  icon: ICONS.COUNTER_CLOCK,
  text: t('Sessions'),
});

const SCHEDULINGS: TMenuLink = ({ t }) => ({
  to: '/area-cliente/agendamentos',
  icon: ICONS.CALENDAR,
  text: t('Schedulings'),
});

export const CUSTOMER_MENU_LINKS = {
  CONTRACTS,
  CUSTOMER_AREA,
  MY_DATA,
  RECOMMENDATIONS,
  SCHEDULINGS,
  SESSIONS,
};
